export default {
  computed: {
    windowSizeLessThan850() {
      return this.windowWidth <= 990;
    },
  },

  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
};
